<template>
	<div class="announcement-sender">
		<ProfilePic
			:user="announcement.sender"
			:size="profileSize"
			class="announcement-sender-pic"
			@click="openProfileCard"
		/>
		<UserName
			class="announcement-sender-name"
			:user="announcement.sender"
			@click="openProfileCard"
		/>
		<MessageTime
			v-if="showDate"
			:date="date"
			:class="{ scheduled: announcement.isScheduled }"
		/>
		<TranslationGlobe
			class="globe"
			v-if="announcement.canTranslate"
			:lang="announcement.lang"
			:translated="announcement.isTranslated"
			:hideTip="!showTranslationTip"
			@click="onClickGlobe"
		/>

		<ProfileCard
			v-if="showProfileCard"
			@close="showProfileCard = false"
			:profileData="announcement.sender"
		/>
	</div>
</template>

<script>
import ProfileCard from '@/components/ProfileCard'
import { UserName, ProfilePic, TranslationGlobe } from '@/components/common'
import MessageTime from '@/components/Message/MessageTime'
import { translateAnnouncement } from '@/api/announcement'

export default {
	name: 'AnnouncementSender',
	components: {
		UserName,
		ProfilePic,
		MessageTime,
		TranslationGlobe,
		ProfileCard,
	},
	props: {
		announcement: Object,
		showProfile: { type: Boolean, default: null },
		showDate: { type: Boolean, default: null },
		showTranslationTip: { type: Boolean, default: null },
		profileSize: { type: String, default: '16px' },
	},
	data() {
		return { showProfileCard: false }
	},
	computed: {
		date() {
			return (
				this.announcement.sent ||
				this.announcement.scheduled ||
				this.announcement.updated_at
			)
		},
	},
	methods: {
		openProfileCard() {
			if (!this.showProfile || !this.announcement.sender) return false
			this.showProfileCard = true
		},
		onClickGlobe() {
			if (!this.showTranslationTip) return
			translateAnnouncement(this.announcement.id)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.announcement-sender {
	@include flex(12px);
	@include fontFamily(900);
	height: 52px;
	.announcement-sender-pic {
		flex-shrink: 0;
	}
	.announcement-sender-name {
		@include ellipsis;
		font-size: 14px;
		:deep(.pronto-icon) {
			color: white !important;
		}
	}
	.message-time {
		margin-left: 0;
		flex-shrink: 0;
		font-size: 13px;
		&.scheduled {
			font-size: 12px;
			@include fontFamily(900);
			padding: 1px 6px;
			border-radius: 4px;
			color: var(--blue-300);
			background: var(--blue-100);
		}
	}
	.globe {
		color: var(--neutral-400);
		font-size: 13px;
		flex-shrink: 0;
	}
}
</style>

<style lang="scss">
@import 'src/sass/variables';

@include overrideContrast {
	.announcement-sender {
		.message-time {
			&.scheduled {
				color: white;
			}
		}
	}
}
</style>
